import { b2cVersion } from '../utils/consts.ts';
import { useGameRoundData } from './useGameRoundData.ts';
import { useRoundInBreak } from './useRoundInBreak.ts';

export const useNextRoundNumber = () => {
  const { data } = useGameRoundData();
  const roundInBreak = useRoundInBreak();

  if (!data) return null;

  if (b2cVersion) {
    return data.round + 1;
  }

  if (roundInBreak) {
    return data.round;
  } else {
    return data.round + 1;
  }
};
